export const ROUTES = {
  home: '/',
  createPost: '/create',
  posts: '/posts',
  createJob: '/createJob',
  uploadResources: '/uploadResources',
  jobs: '/jobs',
  verifyEmail: '/verifyEmail',
  resetLink: '/resetLink',
  login: '/login',
  devConstants: '/__dev/constants',
  logout: '/logout',
  editProfile: '/EditProfile',
  onboarding: '/onboarding',
  resources: '/resources',
  help: '/help',
  adminFeedback: '/adminfeedback',
  qaPage: '/QAPage',
  hiring: '/hiring',
  // dynamic routes – when called without an id, they return the pattern with param
  postDetail: (postId = ':postId') => `/post/${postId}`,
  userProfile: (userId = ':userId') => `/user/${userId}`,
  editPost: (postId = ':postId') => `/create/${postId}`,
};
